var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("img", {
      attrs: {
        src: require(`../../../assets/images/want-more@2x.png`),
        srcset: `${require(`../../../assets/images/want-more@1x.png`)} 1x, ${require(`../../../assets/images/want-more@2x.png`)} 2x, ${require(`../../../assets/images/want-more@3x.png`)} 3x, ${require(`../../../assets/images/want-more@4x.png`)} 4x`,
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "modal-body" }, [
      _c("h2", [_vm._v(_vm._s(_vm._f("trans")("Do you need to do more?")))]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(_vm._f("trans")("Your monthly Credits have been used up."))
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm._f("trans")(
              "If you wish to continue crafting amazing images, it's time to get more Credits."
            )
          )
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }